function normalizeText(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
}

export function hasExplicitWorkloadStructureSignal(value = "") {
  const text = normalizeText(value);
  if (!text) return false;
  if (
    /\b(?:workload|work structure|scattered work|marketing workload|too many moving pieces)\b/i.test(
      text
    )
  ) {
    return true;
  }
  if (
    /\btoo many\s+(?:tasks?|projects?|deadlines?|priorities|commitments|moving pieces)\b/i.test(
      text
    )
  ) {
    return true;
  }
  if (
    /\b(?:work|projects?|tasks?|deadlines?)\b.{0,60}\b(?:overwhelm(?:ed|ing)?|unmanageable|scattered|juggling|competing priorities)\b/i.test(
      text
    )
  ) {
    return true;
  }
  return Boolean(
    /\b(?:organis(?:e|ing|ed)|organiz(?:e|ing|ed)|prioritis(?:e|ing|ed)|prioritiz(?:e|ing|ed)|structur(?:e|ing|ed)|plan(?:ning)?|keep(?:ing)? track of)\s+(?:(?:my|the|our)\s+)?(?:workload|work|projects?|tasks?|deadlines?)\b/i.test(
      text
    )
  );
}
